import { EPaymentMethod } from '@/config/payment';

import type {
  TCreateMethod,
  TCreatePlaidLink,
  TGetMethods,
  TInstantMethod,
  TPaymentsSummary,
  TVerifyMethod,
} from '@/types/wallet';

import { walletService } from '@/api/private';

export const getPaymentMethods: TGetMethods = (
  filters = { paymentMethodType: EPaymentMethod.ACH },
  signal,
) =>
  walletService.get('payment-methods', {
    params: {
      filter: { type: 'SIMPLE', filters },
    },
    signal,
  });

export const createPlaidLink: TCreatePlaidLink = () => walletService.post('create-plaid-link');

export const instantPaymentMethod: TInstantMethod = (data) =>
  walletService.post('payment-methods/instant-verification', data);

export const createPaymentMethod: TCreateMethod = (data) =>
  walletService.post('payment-methods/start-manual-verification', data);

export const verifyPaymentMethod: TVerifyMethod = ({ id, ...data }) =>
  walletService.post(`payment-methods/${id}/finish-manual-verification`, data);

export const getPaymentsSummary: TPaymentsSummary = (signal) =>
  walletService.get('/auto-reload-summary', { signal });
